import type { SortingState } from "@tanstack/react-table";
import type { TimestampSortField } from "../types";

export function getNextSorting(
  sorting: SortingState,
  sortId: string,
  timestampSortFields: readonly TimestampSortField[],
): SortingState {
  const [activeSort] = sorting;

  if (activeSort?.id === sortId) {
    return [{ id: sortId, desc: !activeSort.desc }];
  }

  const isTimestampSort = new Set<string>(timestampSortFields).has(sortId);

  return [{ id: sortId, desc: isTimestampSort }];
}
